import { Directive, ElementRef, Input, OnChanges, SimpleChanges, AfterViewInit, AfterContentInit, OnDestroy, NgZone, Output, EventEmitter } from '@angular/core';
declare var $: any;

@Directive({
  selector: 'div[appSlick]'
})
export class SlickDirective implements OnChanges, OnDestroy {
  @Input() slickOptions = null;
  @Input() slides = null;
  @Output() changeSlick: EventEmitter<any> = new EventEmitter<any>();
  private queryEl: any;
  private children = 0;
  private deafultOptions: any = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: false,
    dots: false,
    customPaging: (slider, i) => {
      if (slider.$slides.get(i).attributes.dotimage) {
        return `<button style="
          background-image: url('${slider.$slides.get(i).attributes.dotimage.value}');
          background-repeat: no-repeat;
          background-size: 101% 101%;
          background-position: 50% 50%;
        "></button>`;
      } else {
        return `<button></button>`;
      }
    },
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };


  constructor(
    private elementRef: ElementRef,
    private zone: NgZone
  ) {
    this.queryEl = $(this.elementRef.nativeElement);
    this.slick();
    // this.detectNewSlides();
    this.reloadInitialSlick();
    this.slickFix();
    this.change();
  }


  /**
   * unslick on destroy
   */
  ngOnDestroy() {
    this.queryEl.slick('unslick');
  }

  /**
   * Detects new slides
   */
  detectNewSlides() {
    setTimeout(() => {
      if (this.children != this.queryEl.children().length) {
        this.updateSlick();
      }
      this.detectNewSlides();
    }, 100);
  }
  /**
   * Slicks fix para slick cuando se redimenciona la pantalla
   */
  slickFix() {
    $(window).on('resize orientationchange', () => {
      this.queryEl.slick('resize');
    });
  }

  /**
   * on changes
   * @param changes parametros actualizados
   * @description actualizar slick
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.slickOptions) {
      this.updateSlick();
    }
  }

  /**
   * Actualiza slick
   */
  updateSlick() {
    if (typeof this.queryEl[0].slick !== 'undefined') {
      this.queryEl.slick('unslick');
    }
    this.slick();
  }

  /**
   * Slicks slick directive
   * @description wrapper de slick js con opciones dinamicas
   */
  slick() {
    this.queryEl.slick(
      {
        ...this.deafultOptions,
        ...(this.slickOptions && typeof this.slickOptions == 'object' ? this.slickOptions : {})
      }
    );
    this.children = this.queryEl.children().length;
  }

  /**
   * Reloads initial slick
   * @description temporal
   */
  reloadInitialSlick() {
    setTimeout(() => {
      if (typeof this.queryEl[0].slick !== 'undefined') {
        this.unslick();
        this.slick();
      }
    }, 100);
  }


  /**
   * cambiar al siguente slide
   */
  next() {
    this.queryEl.slick('slickNext');
  }

  /**
   * cambiar al slide anterior
   */
  prev() {
    this.queryEl.slick('slickPrev');
  }

  /**
   * Unslicks slick directive
   */
  unslick() {
    if (this.queryEl) {
      this.zone.run(() => {
        this.queryEl.slick('unslick');
      });
    }
  }

  change(){
    this.queryEl.on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
      // console.log(slick, currentSlide, nextSlide);
      this.changeSlick.emit({event: event, slick: slick, currentSlide: currentSlide, nextSlide: nextSlide});
    });
  }
}
